import { Component } from '@angular/core';
import { LanguageService } from '../../services/language'; 
import { TranslatePipe } from '@ngx-translate/core';
@Component({
  imports: [TranslatePipe],
  selector: 'app-home',
  styleUrl: './home.component.css',
  templateUrl: './home.component.html',
})
export class HomeComponent {

  
constructor(public languageService: LanguageService){

}

toggleLanguage(): void {
    const current = this.languageService.getLanguage();

    this.languageService.changeLanguage(
      current === 'ar' ? 'en' : 'ar'
    );
  }
}
